import { observable, action } from "mobx";
import { post, get, deleted, put } from "../services/ajax.service";

class UserStore {
  @observable users = [];
  @observable user_drafts = [];
  @observable entitylabel = []
  @observable user_update_logs = [];
  @observable limit = 10;
  @observable logs_limit = 10;
  @observable tiles = 0;
  @observable log_tiles = 0;
  @observable entitiesselect = [];
  @observable action = false;
  @observable errors = {};
  @observable tree = [];
  @observable reportError = "";
  @observable preset_all_users = [];
  @observable selected_preset_all_users = [];
  @observable url = "/api/v1/useractions";
  @observable broker_admin_url = `/api/v1/brokeradminactions`;

  @action setErrors = () => {
    this.errors = {};
  };


  @action setAction = action => {
    this.action = action;
  };

  @action getUsers = async data => {
    let entityData = [];
    if (data.type == "all") {
      entityData = await get(
        `${this.url}/getall?limit=${this.limit}&&offset=${data.offset}&&search=${data.search}&&attr=${data.attr}`
      );
    }
    else {
      entityData = await get(
        `${this.url}/getall/${data.type}?limit=${this.limit}&&offset=${data.offset}&&search=${data.search}&&attr=${data.attr}`
      );
    }
    this.users = entityData.data.rows;
    let count = parseInt(entityData.data.count);
    this.tiles =
      count % this.limit == 0
        ? parseInt(count / this.limit)
        : parseInt(count / this.limit) + 1;

  };
  @action getAllUsersDrafts = async data => {
    let UserDraft = [];
    if (data.type == "all") {
      UserDraft = await get(
        `${this.url}/getAllUsersDrafts?limit=${this.limit}&&offset=${data.offset}&&search=${data.search}&&attr=${data.attr}`
      );
    }
    else {
      UserDraft = await get(
        `${this.url}/getAllUsersDrafts/${data.type}?limit=${this.limit}&&offset=${data.offset}&&search=${data.search}&&attr=${data.attr}`
      );
    }
    this.user_drafts = UserDraft.data.rows;
  };


  @action getUser = async (id, is_broker_admin = false) => {
    let getUser;
    if (is_broker_admin) {
      getUser = await get(`${this.broker_admin_url}/get/${id}`);
    }
    else {
      getUser = await get(`${this.url}/get/${id}`);
    }
    return getUser.data;
  };

  @action selectEntities = async type => {
    const entities = await get(`${this.url}/listentity/${type}`);
    this.entitiesselect = entities.data;
  };

  @action addUser = async (data, history, is_broker_admin = false) => {

    try {
      let Useradd;
      if (is_broker_admin) {
        Useradd = await post(`${this.broker_admin_url}/createuser`, data);
      }
      else {
        Useradd = await post(`${this.url}/create`, data)
        return Useradd
      }
      this.action = true;
      if (is_broker_admin) {
        history.push("/organizationuser");
      }
      else {
        history.push("/portalmanagement/users");

      }
    } catch (e) {
      this.errors = e.response.data;
      return this.errors
    }
  };

  @action deleteUser = async (id, history, is_broker_admin) => {
    try {
      if (is_broker_admin) {
        await deleted(`${this.broker_admin_url}/deleteuser/${id}`);
        history.push("/organizationuser");
      }
      else {
        await deleted(`${this.url}/delete/${id}`);
      }
      var filtered = this.users.filter(user => user.id !== id);
      this.users = filtered;
    } catch (e) {
      console.log(e);
    }
  };
  @action editUser = async (data, history, is_broker_admin = false) => {
    try {
      if (is_broker_admin) {
        await put(`${this.broker_admin_url}/update/${data.id}`, data);
      }
      else {
        await put(`${this.url}/update/${data.id}`, data);

      }
      this.action = true;
      if (is_broker_admin) {
        history.push("/organizationuser");
      }
      else {
        history.push("/portalmanagement/users");
      }
    } catch (e) {
      this.errors = e.response.data;
    }
  };

  @action getEntityTree = async (is_broker_admin = false) => {
    try {
      let data;
      if (is_broker_admin) {
        data = await get(`${this.broker_admin_url}/listentity/data`);
      }
      else {

        data = await get(`${this.url}/listentity/data`);
      }
      this.tree = data.data;
    } catch (e) {
      console.log(e);
    }
  };

  @action getEntitiesByArray = async (data) => {
    try {
      let entities = await post("/api/v1/entityactions/getEntitiesByArray", data);
      this.entitylabel = entities.data;
    } catch (e) {
      console.log(e);
    }
  }

  @action getUserReport = async (data) => {
    try {
      this.reportError = "";
      let result = await post(`${this.url}/getUserReport`,data);
      return true;
    } catch (err) {
      this.reportError = err.response.data
      console.log(err);
      console.log(err);
    }
  }
  @action getAllUsers = async () => {
    try {
      let result = await get(`${this.url}/getAllUsers`);
      this.preset_all_users=result.data.rows;
    } catch (e) {
      console.log(e);
    }
  }
  @action getAllUsersByPresetId = async (presetId) => {
    try {
      let result = await get(`${this.url}/getAllUsersByPresetId/${presetId}`);
      this.selected_preset_all_users=result.data.rows;
      return result.data.rows
    } catch (e) {
      console.log(e);
    }
  }

  @action disbaleUser = async (data) => {
    try {
      let response = await post(`${this.url}/disbaleUser`, data);
      return response.data;
    } catch (e) {
      console.log(e);
    }
  }
  @action enforceResetPassword = async (data) => {
    try {
      await put("/api/v1/secureAuthActions/enforceResetPassword", data);
      return;
    } catch (e) {
      console.log(e);
    }
  }

  @action getUserUpdateLogs = async (id, offset, type = "", filter = "") => {
    try {
      let data;
      data = await get(`${this.url}/getallLogs/${id}?limit=${this.logs_limit}&&offset=${offset}&&type=${type}&&filter=${filter}`);
      this.user_update_logs = data.data.rows;
      let count = parseInt(data.data.count);
      this.log_tiles =
        count % this.logs_limit == 0
          ? parseInt(count / this.logs_limit)
          : parseInt(count / this.logs_limit) + 1;
    } catch (e) {
      console.log(e);
    }
  };
}

export default UserStore;